/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Delete_Terms_Title_ConfirmInputs */



/**
* | output |
* | --- |
* | "Delete Terms?" |
*
* @param {Knp_Lookup_Delete_Terms_Title_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_delete_terms_title_confirm = /** @type {((inputs?: Knp_Lookup_Delete_Terms_Title_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Delete_Terms_Title_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer des termes ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nutzungsbedingungen löschen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare i termini?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить условия?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar términos?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除条款？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用規約を削除しますか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शर्तें हटाएं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir termos?")
	return /** @type {LocalizedString} */ ("Delete Terms?")
});